import { HTTPStatusCodes } from 'constants/httpStatusCodes';

export const DECLINATION_STATUS = {
  NoOffer: 'NoOffer',
  Declined: 'Declined'
};

export const RETRYABLE_STATUS_CODES = [
  HTTPStatusCodes.RequestTimeout,
  HTTPStatusCodes.TooManyRequests
];

export const DECLINATION_REASONS_FIELD_NAMES = {
  DeclinedFields: 'declined_fields',
  DeclinationNotes: 'declination_notes'
};
